import React from 'react'
import { cva } from 'class-variance-authority'
import { XIcon } from 'lucide-react'

import { cn } from '@/shared/lib/utils'

import { Button } from './button'

const StateButton = ({
	onClear,
	children,
	variant,
	className,
	size = 'default',
	disabled,
	active,
	...props
}: React.ComponentProps<typeof Button> & {
	active?: boolean
	onClear: () => void
}) => (
	<div
		data-slot='state-button'
		className={cn(
			'group/state-button relative inline-flex items-center',
			{
				active,
			},
			className
		)}
	>
		<Button
			variant={variant}
			disabled={disabled}
			data-active={active}
			size={size}
			className={cn(active && 'group-hover/state-button:pr-8', {
				'group-hover/state-button:pr-5': active && size === 'xs',
				'group-hover/state-button:pr-7': active && size === 'sm',
				'group-hover/state-button:pr-8': active && size === 'lg',
			})}
			{...props}
		>
			{children}
		</Button>
		{active && (
			<Button
				onClick={onClear}
				data-size={size}
				variant={variant}
				data-active={active}
				disabled={disabled}
				className={cn(
					stateButtonCloseVariants({ size: size as 'default' | 'xs' | 'sm' }),
					'hidden group-hover/state-button:inline-flex',
					'absolute top-1 right-1'
				)}
			>
				<XIcon strokeWidth={3} className='size-3' />
			</Button>
		)}
	</div>
)
StateButton.displayName = 'StateButton'
const stateButtonCloseVariants = cva(
	'gap-2 text-sm shadow-none flex items-center',
	{
		variants: {
			size: {
				default: 'size-6 rounded-[calc(var(--radius)-1px)] p-0 has-[>svg]:p-0',
				sm: 'size-5 rounded-[calc(var(--radius)-3px)] p-0 has-[>svg]:p-0',
				xs: 'size-3 rounded-[calc(var(--radius)-3px)] p-0 has-[>svg]:p-0',
			},
		},
		defaultVariants: {
			size: 'default',
		},
	}
)
export { StateButton, stateButtonCloseVariants }
